import { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSwipeable } from "react-swipeable";

import moment from "../../helper/moment";
import Icon from "../Icon";
import Input from "../Input";
import { useAtom } from "jotai";
import MiniCard from "../MiniCardUI";
import { logout } from "../../api/auth";
import { colorAvatarAtom } from "../../state/constants";
import { userAtom } from "../../state/auth";
import { screenBreakpoints } from "../../config/theme";

import { ReactComponent as WomanPatient } from "../../assets/illustrations/illustration-femme-patient.svg";
import { ReactComponent as ManPatient } from "../../assets/illustrations/illustration-homme-patient.svg";
import { refreshAtomNotification } from "../../state/refreshStateNotifications";

import { ReactComponent as IconSearch } from "../../assets/icons/icon-search.svg";
import EmojiSmileSick from "../../assets/images/smileSick.png";
import EmojiCamera from "../../assets/images/camera.png";
import EmojiMoney from "../../assets/images/money.png";

import { getUnreadMsg } from "../../api/messages";

import "./styles.scss";
import _ from "lodash";

import ChatModal from "../SharedChat";

const SideBarDoctor: React.FC = (demandeData?: any) => {
  const [user, setUser] = useAtom(userAtom) as any;
  const [patientName, setPatientName] = useState("");
  const [colorAvatar] = useAtom<any>(colorAvatarAtom);
  const [path, setPath] = useState(window.location.pathname);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [notification, setNotifications] = useState([]) as any;
  const [chatModal, setChatModal] = useState();
  const [refreshUnReadMsg, setRefreshUnReadMsg] = useAtom(
    refreshAtomNotification
  );
  const [menuToggleIsActive, setMenuToggleIsActive] = useState(
    window.innerWidth <= screenBreakpoints.md
  );
  const [forceMenuOpen, setForceMenuOpen] = useState(false);

  const swipeEventsHandlers = useSwipeable({
    onSwipedLeft: () => {
      setForceMenuOpen(false);
    },
    onSwipedRight: () => {
      setForceMenuOpen(true);
    },
  });

  const history = useHistory();

  const _getUnreadMsg = async () => {
    try {
      const response = await getUnreadMsg();
      setNotifications(_.uniqBy(response, "sentFrom._id"));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    _getUnreadMsg();
  }, [ChatModal, refreshUnReadMsg]);

  const specialistStat = [
    { name: "patients", score: "37", emoji: EmojiSmileSick, direction: "col" },
    {
      name: "revenu total",
      score: "1560 €",
      emoji: EmojiMoney,
      direction: "col",
    },
    {
      name: "télé-consultations",
      score: "41",
      emoji: EmojiCamera,
      direction: "row",
    },
  ];

  const extraMenu = () => {
    switch (path) {
      case "/specialist":
      case "/mes-patients":
        return (
          <div className="mt-2 w-full">
            <div>
              <div className="flex items-center space-x-2">
                <span className="link uppercase">quelques chiffres</span>
                <Icon isIcon={true} name={"reglage-haut_droite"} />
              </div>

              <span className="card-subtitle -mt-2 mb-2 block">
                depuis le 1er {moment().format("MMMM")}
              </span>
            </div>
            <div className="flex flex-wrap">
              {specialistStat.map(({ name, score, emoji, direction }) => (
                <MiniCard
                  name={name}
                  score={score}
                  emoji={emoji}
                  direction={direction}
                />
              ))}
            </div>
          </div>
        );

      case "/agenda":
        return <div className="border border-blue-500 h-60 w-full"></div>;
      default:
        return;
    }
  };

  const menus = [
    {
      icon: "patient-tableau",
      text: "Demandes",
      url: "/demandes",
    },
    {
      icon: "patient",
      text: "Mes Patients",
      url: "/mes-patients",
    },

    {
      icon: "monCompte",
      text: "Mon compte",
      url: "/profile",
    },
  ];

  const handleLogout = async () => {
    try {
      await logout(user);
      setPath("/");
      window.location.href = "/";
      localStorage.clear();
    } catch (error) {
      window.location.href = "/";
      localStorage.clear();
      console.error(error);
    }
  };

  const imageBaseUrl = `${process.env.REACT_APP_KATOMI_API_URL}/v${process.env.REACT_APP_KATOMI_API_VERSION}`;
  useEffect(() => {
    setPath(window.location.pathname);

    const handleWindowResize = () => {
      setScreenWidth(window.innerWidth);
      setMenuToggleIsActive(window.innerWidth <= screenBreakpoints.md);
    };

    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  useEffect(() => {
    console.log("[debug] sidebar - ", { menuToggleIsActive });
  }, [menuToggleIsActive]);

  useEffect(() => {
    console.log("[debug] sidebar - ", { screenWidth });
  }, [screenWidth]);

  return (
    <>
      <ChatModal
        chatWithId={chatModal}
        showModal={!!chatModal}
        closeChatModal={() => setChatModal(undefined)}
      />{" "}
      <div className="sidebar-doctor sidebar">
        <div
          className={`swipe-events-container ${
            !menuToggleIsActive || !forceMenuOpen ? "" : "swipeable-fullscreen"
          }`}
          {...swipeEventsHandlers}
        />
        <div
          className={`sidebar-container absolute transform md:relative md:translate-x-0 transition duration-200 ease-in-out ${
            menuToggleIsActive ? "mobile-sidebar" : "bg-transparent"
          } ${menuToggleIsActive && !forceMenuOpen ? "-translate-x-full" : ""}`}
        >
          <div className="relative">
            {/* <!-- SIDEBAR --> */}

            {/* mobile menu */}
            <div className="flex z-0 justify-between md:hidden absolute mobile-menu-burger">
              <button
                className="p-4 focus:outline-none"
                onClick={() => {
                  setForceMenuOpen(!forceMenuOpen);
                }}
              >
                <Icon isIcon={true} name={forceMenuOpen ? "close" : "menu"} />
              </button>
            </div>
            {/* mobile menu END */}

            <div className="flex items-center relative notification ">
              {user ? (
                <div
                  className="relative w-12 h-12 rounded-[15px] overflow-hidden flex items-center justify-center"
                  style={{ backgroundColor: colorAvatar }}
                >
                  {user?.gender === "female" ? (
                    <WomanPatient className="w-full h-full -mt-2" />
                  ) : (
                    <ManPatient className="w-full h-full -mt-2" />
                  )}

                  {!_.isEmpty(notification) && (
                    <Icon
                      isIcon
                      className="absolute -right-3 -top-2 cursor-pointer"
                      name="notif-deconnexion"
                    />
                  )}
                </div>
              ) : (
                <div
                  className="avatar-doctor"
                  style={{ backgroundColor: colorAvatar }}
                >
                  <ManPatient className="-mt-2" />
                </div>
              )}

              <div className="ml-3">
                <span className="menu">
                  {user?.firstName} {user?.lastName}
                </span>
                <p className="docter-center">{user?.speciality}</p>
                {!_.isEmpty(notification) && (
                  <p className="notif-text">{"Nouveau message"}</p>
                )}
              </div>
              <div className="w-64 max-h-96 bg-white absolute top-7 overflow-auto rounded-2xl notification-list">
                {!_.isEmpty(notification) &&
                  notification.map((el) => (
                    <div
                      className="flex space-x-3 items-center p-2 hover:bg-blue-100 cursor-pointer"
                      onClick={() => setChatModal(el.chatroom)}
                      //key={el._id}
                    >
                      <p className="w-14 h-10  rounded-full bg-blue-500 flexCenter text-white text-bold">
                        {el.sentFrom.lastName[0].toUpperCase() +
                          el.sentFrom.firstName[0].toUpperCase()}
                      </p>
                      <p>
                        {el.sentFrom.lastName + " " + el.sentFrom.firstName}{" "}
                        vous a envoyé un message
                      </p>
                    </div>
                  ))}
              </div>
            </div>

            <nav className="mt-3">
              {menus.map((menu) => {
                return (
                  <div className={path === menu.url ? "selected-menu" : ""}>
                    <Link
                      to={menu.url}
                      className="flex items-center space-x-3 py-3"
                      onClick={() => setPath(menu.url)}
                    >
                      <div className="w-12 h-12 flexCenter">
                        <Icon isIcon={true} name={menu.icon} />
                      </div>
                      <span className="my-auto menu">{menu.text}</span>
                    </Link>
                  </div>
                );
              })}
              <div className={path === "/logout" ? "selected-menu" : ""}>
                <span
                  // to={"/"}
                  className="flex items-center space-x-3 py-3 cursor-pointer"
                  onClick={handleLogout}
                >
                  <div className="w-12 h-12 flexCenter">
                    <img
                      src={require("../../assets/images/logout.png").default}
                      width="22"
                      alt="logout"
                    />
                  </div>
                  <span className="my-auto menu">Se déconnecter</span>
                </span>
              </div>

              {/* {extraMenu()} */}
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBarDoctor;
